import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Yarn } from '../../models/item/yarn';

import { ItemMaster } from '@app/models/item/item-master/item-master';
import { MatchingItemMasterCommand } from '@app/models/yarn/yarn-search';
import { Observable } from 'rxjs';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class YarnProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/yarn';

  public getAll(): Observable<ApiResponse<Yarn[]>> {
    return this.httpClient.get<ApiResponse<Yarn[]>>(`${this.baseUrl}/all`);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public search(command: any): Observable<ApiResponse<PaginatedApiResponse<Yarn>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Yarn>>>(`${this.baseUrl}/search`, command);
  }

  getItemMastersByYarnCode(command: MatchingItemMasterCommand[]): Observable<ApiResponse<Record<string, ItemMaster | null>>> {
    return this.httpClient.post<ApiResponse<Record<string, ItemMaster | null>>>(`${this.baseUrl}/yarn-code/batch/item-master`, command);
  }
}
